export const PostHogEvent = {
  TWO_YEAR_PARTS_CONTACT_CLICKED: '2-year-parts-contact-clicked',
  TWO_YEAR_PARTS_WEBSITE_CLICKED: '2-year-parts-website-clicked',
  APPLIANCE_DETAILS_CONTINUE_CTA_CLICKED: 'appliance-details-continue-cta-clicked',
  APPLIANCE_LOCATION_BACK_CLICKED: 'appliance-location-back-clicked',
  APPLIANCE_LOCATION_CONTINUE_CTA_CLICKED: 'appliance-location-continue-cta-clicked',
  APPLIANCE_LOCATION_MANUAL_CLICKED: 'appliance-location-manual-clicked',
  APPLIANCE_LOCATION_TERMS_CHECKBOX_CHANGED: 'appliance-location-terms-checkbox-changed',
  APPLIANCE_LOCATION_VALIDATION_FAILED_ON_CONTINUE:
    'appliance-location-validation-failed-on-continue',
  CALL_US_MODAL_CALL_CLICKED: 'call-us-modal-call-clicked',
  CALL_US_MODAL_CLOSED: 'call-us-modal-closed',
  CALL_US_MODAL_DISPLAYED: 'call-us-modal-displayed',
  CHECKOUT_FAQ_CLICKED: 'checkout-faq-clicked',
  CHECKOUT_FORM_ERROR: 'checkout-form-error',
  CHECKOUT_PAYMENT_METHOD_SELECTED: 'checkout-payment-method-selected',
  CHECKOUT_SETUP_PROTECTION_CLICKED: 'checkout-setup-protection-clicked',
  CHECKOUT_TERMS_CLICKED: 'checkout-terms-clicked',
  CONFIRMATION_UPSELL_CLICKED: 'confirmation-upsell-clicked',
  DATE_BACK_CLICKED: 'date-back-clicked',
  DATE_CONTINUE_CTA_CLICKED: 'date-continue-cta-clicked',
  ENHANCED_PROTECTION_RADIO_SELECTED: 'enhanced-protection-radio-selected',
  ERROR_PHONE_CLICKED: 'error-phone-clicked',
  HEADER_CALL_US_CLICKED: 'header-call-us-clicked',
  LOCATION_ADDRESS_TICKED: 'location-address-ticked',
  LOCATION_ADDRESS_UNTICKED: 'location-address-unticked',
  MODEL_ENTERED: 'model-entered',
  MODEL_SERIAL_BACK_CLICKED: 'model-serial-back-clicked',
  MODEL_SERIAL_CONTACT_CLICKED: 'model-serial-contact-clicked',
  MODEL_SERIAL_CONTINUE_CTA_CLICKED: 'model-serial-continue-cta-clicked',
  NO_MODEL_SERIAL_CTA_CLICKED: 'no-model-serial-cta-clicked',
  PERSONAL_DETAILS_BACK_CLICKED: 'personal-details-back-clicked',
  PERSONAL_DETAILS_CONTINUE_CTA_CLICKED: 'personal-details-continue-cta-clicked',
  PERSONAL_DETAILS_MANUAL_CLICKED: 'personal-details-manual-clicked',
  PERSONAL_DETAILS_TERMS_CHECKBOX_CHANGED: 'personal-details-terms-checkbox-changed',
  PERSONAL_DETAILS_VALIDATION_FAILED_ON_CONTINUE: 'personal-details-validation-failed-on-continue',
  PRICE_BACK_CLICKED: 'price-back-clicked',
  PRICE_CONTINUE_CTA_CLICKED: 'price-continue-cta-clicked',
  PROTECTION_DETAILS_DISPLAY_SIDE_DRAWER: 'protection-details-display-side-drawer',
  PROTECTION_DETAILS_MODAL_MONTHLY_UPSELL_CTA_CLICKED:
    'protection-details-modal-monthly-upsell-cta-clicked',
  PROTECTION_DETAILS_MODAL_REGISTER_ONLY_CTA_CLICKED:
    'protection-details-modal-register-only-cta-clicked',
  PROTECTION_DETAILS_PAGE_MONTHLY_UPSELL_CTA_CLICKED:
    'protection-details-page-monthly-upsell-cta-clicked',
  PROTECTION_DETAILS_PAGE_REGISTER_ONLY_CTA_CLICKED:
    'protection-details-page-register-only-cta-clicked',
  PROTECTION_DETAILS_SIDE_DRAWER_MONTHLY_UPSELL_CTA_CLICKED:
    'protection-details-side-drawer-monthly-upsell-cta-clicked',
  PROTECTION_DETAILS_SIDE_DRAWER_REGISTER_ONLY_CTA_CLICKED:
    'protection-details-side-drawer-register-only-cta-clicked',
  PROTECTION_DETAILS_SELECTION_VALIDATION_FAILED: 'protection-details-selection-validation-failed',
  REGISTRATION_FAILURE: 'registration-failure',
  REGISTRATION_ONLY_ORDER_CONFIRMATION_LOADED: 'registration-only-order-confirmation-loaded',
  REGISTRATION_UPSELL_ORDER_CONFIRMATION_LOADED: 'registration-upsell-order-confirmation-loaded',
  REGISTRATION_WITH_QUOTE: 'registration-with-quote',
  REGISTRATION_WITHOUT_QUOTE: 'registration-without-quote',
  SERIAL_ENTERED: 'serial-entered',
  SUB_APPLIANCE_SELECTED: 'sub-appliance-selected',
  SUPER_APPLIANCE_SELECTED: 'super-appliance-selected',
  WARRANTY_RADIO_SELECTED: 'warranty-radio-selected',
} as const;

export type PostHogEvent = (typeof PostHogEvent)[keyof typeof PostHogEvent];
